import React from 'react'
import PropTypes from 'prop-types'

const ErrorMessage = ({ children, error }) => (
    <div className="errors">
        <div className="text-danger">
            { error }
            { children }
        </div>
    </div>
)

ErrorMessage.propTypes = {
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
}

export default ErrorMessage
